<div class="date-range-container" [ngClass]="config?.classes">
  <label *ngIf="config?.label" class="date-range-label">{{ config.label }}</label>

  <!-- Pre-defined options dropdown -->
  <div *ngIf="config?.options && config.options.length > 0" class="date-range-options">
    <mat-select [value]="selectedOption" placeholder="Select date range" [tabIndex]="config?.tabIndex"
      (selectionChange)="onOptionSelected($event.value)">
      <mat-option *ngFor="let option of config.options" [value]="option">
        {{ option.label | translate }}
      </mat-option>
    </mat-select>
  </div>

  <!-- Date range picker -->
  <div class="date-range-picker">
    <mat-datepicker-toggle matIconSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
    <mat-date-range-picker #dateRangePicker (closed)="closed(dateRangeStart, dateRangeEnd)"></mat-date-range-picker>
    <mat-date-range-input class="date-range-input" [rangePicker]="dateRangePicker" [min]="config?.minDate"
      [max]="config?.maxDate" [disabled]="config?.disabled">

      <input matStartDate #dateRangeStart [value]="startDate" [placeholder]="config?.startPlaceholder || 'Start date'"
        [tabIndex]="config?.tabIndex" (dateChange)="onStartDateChange($event)">

      <input matEndDate #dateRangeEnd [value]="endDate" [placeholder]="config?.endPlaceholder || 'End date'"
        [tabIndex]="config?.tabIndex" (dateChange)="onEndDateChange($event)">
    </mat-date-range-input>
  </div>

  <div *ngIf="currentErrorMessage" class="date-range-error">
    {{ currentErrorMessage }}
  </div>
</div>